import { IconBrandAuth0, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import IconButton from '../../../components/Buttons/IconButton';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { ORG_LIST, PROFILE } from '../../../statics/localStorage';
import { accessCodeArrayToAccessGroup } from '../../../utils/dataInterChange';

const AssignAccessModal = ({ memberData, callback }) => {
    const [show, setShow] = useState(false);
    const [accessPresets, setAccessPresets] = useState([]);
    const [currentPresetId, setCurrentPresetId] = useState(memberData?.accessPresetId || null);

    useEffect(() => {
        if (show) {
            setCurrentPresetId(memberData?.accessPresetId || accessPresets[0]?._id);
        }
    }, [show, memberData?.accessPresetId, accessPresets]);

    const orgList = ORG_LIST();
    const profileData = PROFILE();

    const handleClose = () => { setAccessPresets([]); setCurrentPresetId(null); setShow(false) };
    const handleShow = () => setShow(true);

    let currentOrg = orgList.find(org => org.organizationId == profileData?.defaultOrganizationId);

    async function getAccessPresets() {
        loadingShow();
        let resp = await getApi(urlApi.accessPresetList);
        loadingHide();
        if (resp.responseCode === 200) {
            setAccessPresets(resp.data);
            setCurrentPresetId(memberData?.accessPresetId || resp?.data[0]?._id)
            handleShow();
        } else {
            toast.error(resp.message);
        }
    }

    const submit = async () => {
        let resp = await getApi(urlApi?.assignAccessToMember + memberData?.userId + "/" + currentPresetId);
        if (resp.responseCode === 200) {
            callback?.();
            handleClose();
            toast.success(resp?.message);
        } else {
            toast.error(resp?.message);
        }
    }

    return (
        <>
            <IconButton icon={<IconBrandAuth0 size={18} />} onClickFunction={() => getAccessPresets()} text={"Access"} />

            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Assign Access to {memberData?.name || 'member'} of {currentOrg?.name || 'current'} Organization</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <p className='mb-3 text-sm font-light text-center text-orange-600 italic'> Assign a access level for specific permission of this team member. </p>

                    <select className='px-3 py-2 mb-3 rounded-md border-2 text-sm w-full' defaultValue={accessPresets?.find((data) => data?._id == memberData?.accessPresetId) ? memberData?.accessPresetId : ''} onChange={(e) => setCurrentPresetId(e.target.value)}>
                        <option value={''} disabled>Select Access Level</option>
                        {
                            accessPresets.map(preset => (
                                <option key={preset._id} value={preset._id}>{preset.name}</option>
                            ))
                        }
                    </select>

                    {currentPresetId && <p className="mb-4">Access Preview : {!accessPresets?.find((data) => data?._id == memberData?.accessPresetId) && "Select a Access preset to view."} </p>}
                    <div className='grid grid-cols-2 md:grid-cols-3 gap-3'>
                        {
                            Object.entries(accessCodeArrayToAccessGroup(accessPresets?.find(preset => preset?._id == currentPresetId)?.accessCodes))?.map(([key, value], index) => {
                                return (
                                    <div key={index}>
                                        <p className='text-sm mb-1'>{index + 1} : <span className='underline'>{key}</span></p>
                                        <div className='!ps-2.5'>
                                            {
                                                value.map((access, index) => (
                                                    <p key={index} className='text-xs font-light'> &#x2022; {access?.name ?? "--"}</p>
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <hr className='my-3' />

                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Assign</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AssignAccessModal